import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const StructureCorporateAPI = (props) => {
  return axios.get(
    `${env.HOST}/${props === 'struktur-organisasi' ? 'struktur-organisasi' : `struktur-manajemen/${props}`}`,
    {
      headers
    }
  );
};
export default StructureCorporateAPI;
